import { FC } from "react"
import { AttachmentModel } from "./components/AttachmentModel"
import { Box } from "@mui/material"
import { AttachmentList } from "./AttachmentList"
import { Attachment3D } from "./components/Attachment3D"
import { TopPanel } from "./components/TopPanel"
import { useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { attachmentModule, wasmModule } from "@/gluelayer"
import { ULoading } from "@/ui-component"
import React from "react"

interface SingleAttachmentProps {
  open: boolean
  onClose: () => void
}

export const SingleAttachment: FC<SingleAttachmentProps> = ({
  open,
  onClose,
}) => {
  const DefineAttachment = useAppSelector((state: RootState) => state.userService.clinicalSettings.DefineAttachment)

  const [wasmReady, setWasmReady] = React.useState(false)

  React.useEffect(() => {
    if (!open) {
      setWasmReady(false)
    }
  }, [open])

  const passDatatoWasm = () => {
    try {
      attachmentModule.SetSingleAttachmentSettingJson(
        JSON.stringify(DefineAttachment),
      )
      wasmModule.ulabwinIns.ShowSingleAttachmentSetting(0)
    } catch (err) {
      console.error("Pass data to wasm failed:", err)
      setWasmReady(true)
    }

    setWasmReady(true)
  }

  console.log("wasmready:", wasmReady)

  return (
    <AttachmentModel title="Single Attachment" open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: 70,
          left: 18,
          width: "404px",
          height: "auto",
          zIndex: 1,
        }}
      >
        <AttachmentList showSave={true} />
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: 68,
          left: 340,
          width: "600px",
          height: "80px",
          zIndex: 1,
        }}
      >
        <TopPanel />
      </Box>
      <Attachment3D initCallBack={passDatatoWasm} />

      <ULoading isLoading={!wasmReady} />
    </AttachmentModel>
  )
}
